export default __webpack_public_path__ + "9df6acb35d25c972ac5e8d892341042d.svg";